/* 🤖 this file was generated by svg-to-ts */
export const DfIconCheckmark16: {
  name: 'checkmark-16';
  data: string;
} = {
  name: 'checkmark-16',
  data: `<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="m13.492 3.356.111.115a1.511 1.511 0 0 1 0 2.041l-6.481 7.059a1.32 1.32 0 0 1-.856.424L6.13 13a1.318 1.318 0 0 1-.885-.356l-.074-.073-2.774-3.022a1.511 1.511 0 0 1 0-2.041l.038-.042a1.322 1.322 0 0 1 1.877-.073l.073.073 1.76 1.918 5.47-5.955a1.322 1.322 0 0 1 1.877-.073z"/></svg>`
};
